import React, { useState } from "react";
import "./companypage.css";
import "bootstrap/dist/css/bootstrap.min.css";

/**
 * @type {React.ExoticComponent<import('@szhsin/react-accordion').AccordionItemProps>}
 */

const CompanyPage = (props) => {
  const [selectedProject, setSelectedProject] = useState("");

  const selectedProjectData =
    props.projects && props.projects.find((project) => project.name === selectedProject);

  return (
    <div className="companypage">
      <div className="company-header">
        <img
          src={props.image}
          className="company-logo"
          alt={props.companyname}
        />
        <div className="company-info">
          <h3 className="designation">{props.designation}</h3>
          <h4 className="duration">{props.duration}</h4>
        </div>
      </div>

      <div className="brief">{props.brief}</div>

      <div className="project-pills">
        {props.projects.map((project) => (
          <button
            key={project.id || project.name}
            type="button"
            className={`project-pill ${
              selectedProject === project.name ? "project-pill-selected" : ""
            }`}
            onClick={() =>
              setSelectedProject((current) =>
                current === project.name ? "" : project.name
              )
            }
          >
            {project.name}
          </button>
        ))}
      </div>

      {selectedProjectData && (
        <div className="project-detail">
          {selectedProjectData.description}
        </div>
      )}
    </div>
  );
};

export default CompanyPage;
